import { Component, input } from "@angular/core";
import { CheckIcon, LucideAngularModule, XIcon } from "lucide-angular";
import { OriBadgeComponent } from "~/components/ui/badge";


@Component({
  standalone: true,
  imports: [
    OriBadgeComponent,
    LucideAngularModule
  ],
     
  template: `
    <ori-badge class="gap-1.5 font-sans font-semibold rounded-md w-[70px]" variant="outline"> 
    @if (value() == 'Active' || value() == '1') {
      <span class="bg-emerald-500 rounded-full">
        <lucide-angular class=" text-white" [img]="CheckIcon" size="13" strokeWidth="3" aria-hidden="true"/>
      </span>
      Active
    }
    @else if(value() == 'Inactive' || value() == '0') {
      <span class="bg-red-500 rounded-full">
        <lucide-angular class=" text-white" [img]="XIcon" size="13" strokeWidth="3" aria-hidden="true"/>
      </span>
      Inactive
    }
    </ori-badge>
  `,
})
export class  StatusCellComponent  {
  readonly value = input<unknown>();
  readonly CheckIcon = CheckIcon;
  readonly XIcon = XIcon;
}
